import ReducerRegistry from '../../../../react/features/base/redux/ReducerRegistry';

import { HIDE_WILDIX_MODAL, SHOW_WILDIX_MODAL } from './actionTypes';

export const DEFAULT_STATE = {
    modal: null
};

ReducerRegistry.register('wildix/features/modal', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case SHOW_WILDIX_MODAL:
        return {
            ...state,
            modal: {
                component: action.component,
                id: action.id,
                props: action.props
            }
        };
    case HIDE_WILDIX_MODAL:
        return {
            ...state,
            modal: null
        };
    default:
        return state;
    }
});
